/**
 * Collect cache hit/miss ratio metrics for static assets
 * @param bundlesToPrecache Bundle names configured for service worker precaching
 * @returns Record containing cache metrics, or null if Performance API is not supported or no resources are found
 */ export function collectScriptCacheMetrics(bundlesToPrecache) {
    if (!performance?.getEntriesByType) {
        return null;
    }
    const resourceEntries = performance.getEntriesByType("resource");
    if (resourceEntries.length === 0) {
        return null;
    }
    let bundlePrecacheCacheHits = 0;
    let scriptCacheHits = 0;
    let otherCacheHits = 0;
    let totalTransferSize = 0;
    let totalEncodedSize = 0;
    let totalScripts = 0;
    let totalBundlePrecache = 0;
    let totalOther = 0;
    for (const entry of resourceEntries){
        const isScript = entry.initiatorType === "script";
        const fileName = entry.name.split("/").pop() ?? "";
        const bundleName = fileName.match(/^(.+)\.[a-f0-9]{10}\.(?:chunk|bundle)\.js$/)?.[1];
        const isPrecachedBundle = bundleName !== undefined && bundlesToPrecache.includes(bundleName);
        if (isPrecachedBundle) {
            totalBundlePrecache++;
        } else if (isScript) {
            totalScripts++;
        } else {
            totalOther++;
        }
        if (entry.transferSize === 0) {
            if (isPrecachedBundle) {
                bundlePrecacheCacheHits++;
            } else if (isScript) {
                scriptCacheHits++;
            } else {
                otherCacheHits++;
            }
        }
        totalEncodedSize += entry.encodedBodySize || 0;
        totalTransferSize += entry.transferSize || 0;
    }
    return {
        totalScripts: totalScripts.toString(),
        totalBundlePrecache: totalBundlePrecache.toString(),
        totalOther: totalOther.toString(),
        precacheCacheHits: bundlePrecacheCacheHits.toString(),
        scriptCacheHits: scriptCacheHits.toString(),
        otherCacheHits: otherCacheHits.toString(),
        totalTransferSize: totalTransferSize.toString(),
        totalEncodedSize: totalEncodedSize.toString()
    };
}
